var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-body-1 font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider',{staticClass:"mb-3"}),_vm._l((_vm.items),function(ref,i){
var title = ref.title;
var path = ref.path;
return _c('v-card',{key:i,staticClass:"d-flex mb-3",attrs:{"outlined":"","href":_vm.files + path,"download":title,"target":"_blank"}},[_c('v-icon',{staticClass:"ml-4"},[_vm._v("fas fa-file")]),_c('v-card-text',{staticClass:"black--text"},[_vm._v(_vm._s(title))])],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }